import FileCard from "../components/FileCard";
import {Button, Divider, Result, Modal, notification, Form, Input} from "antd";
import {FrownOutlined,} from "@ant-design/icons"
import React, {useContext, useState} from "react";
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import BranchInfo from "../utilis/models/branchInfo";
import {EditNameValidation, Validation} from "../utilis/tools/validation";
import AuthContext from "../utilis/contexts/AuthContext";


const ManageFiles = () => {
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [changeNameModalOpen, setChangeNameModalOpen] = useState(false)
    const [confirmLoading, setConfirmLoading] = useState(false);
    const {branches,user,Token,handleCurrentBranchInfo,currentFileNumber:authCurrentFileNumber,handleCurrentFileNumber,handleBranches} = useContext(AuthContext);
    const [currentFileNumber,setCurrentFileNumber]=useState('');
    const [alias,setCurrentAlias]=useState('');
    const [form] = Form.useForm();
    const handleDelete = (fileNumber: string) => {
        setCurrentFileNumber(fileNumber)
        form.resetFields()
        setDeleteModalOpen(true)
        setConfirmLoading(false)
    }
    const handleChangeName = (fileNumber: string,alias:string) => {
        setCurrentFileNumber(fileNumber)
        setCurrentAlias(alias);
        setConfirmLoading(false)
        setChangeNameModalOpen(true)
        form.resetFields()
    }
    const changeNameFile=(value:any)=>{
        setConfirmLoading(true)
        Api.post(Urls.EditBranchAlias, {
            Cellphone: user.cellphone,
            FileNumber: currentFileNumber,
            Alias: value.Name,
        }, {
            headers: {

                "Authorization": Token.tokenType + " " + Token.accessToken
            }
        }).then((response: AxiosResponse) => {
            const {data}=response;
            const {Status,Message,Data}=data;
            if(Status===0){

                handleBranches(Data.branches)
                if(!Data.branches.length){
                    handleCurrentBranchInfo(new BranchInfo())
                    handleCurrentFileNumber(null)
                }
                notification['success']({
                    message: Message,
                    duration: 120
                });
            }
            if(Status===-1){

                notification['error']({
                    message: Message,
                    duration: 120
                });
            }
        }).catch((e: AxiosError) => {

        }).finally(() => {
            setChangeNameModalOpen(false)
            setConfirmLoading(false)
        })
    }
    const deleteFile = (fileNumber: string) => {

        setConfirmLoading(true)
        Api.post(Urls.DeleteBranch, {
            Cellphone: user.cellphone,
            FileNumber: fileNumber,
        }, {
            headers: {

                "Authorization": Token.tokenType + " " + Token.accessToken
            }
        }).then((response: AxiosResponse) => {
            const {data}=response;
            const {Status,Message,Data}=data;
            if(Status===0){
                if(fileNumber===authCurrentFileNumber){
                    handleCurrentFileNumber(null)
                }
                handleBranches(Data.branches)
                if(!Data.branches.length){
                    handleCurrentBranchInfo(new BranchInfo())
                    handleCurrentFileNumber(null)
                }
                notification['success']({
                    message: Message,
                    duration: 120
                });
            }
            if(Status===-1){

                notification['error']({
                    message: Message,
                    duration: 120
                });
            }
        }).catch((e: AxiosError) => {

        }).finally(() => {
            setDeleteModalOpen(false)
            setConfirmLoading(false)
        })
    }
    return <>
        <Divider><h3 className="font-bold ">مدیریت پرونده ها</h3></Divider>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:grid-cols-3">
            {branches.map((branch: any, index) => {
                return <FileCard alias={branch.alias} key={branch.file_number} fileNumber={branch.file_number} handleDelete={handleDelete}
                                 handleChangeName={handleChangeName}/>
            })}

        </div>
        {!branches.length &&  <Result
            icon={<FrownOutlined />}
            title="هیچ پرونده ای یافت نشد."

        />}
        <Modal title="هشدار" footer={[<Button key="back" onClick={() => {
            setDeleteModalOpen(false);
            setConfirmLoading(false)
        }}>
            بستن
        </Button>,
            <Button key="delete" loading={confirmLoading} type={"primary"} danger onClick={() => deleteFile(currentFileNumber)}>
                حذف
            </Button>]} confirmLoading={confirmLoading} open={deleteModalOpen}>
            <p>آیا می‌خواهید پرونده را حذف کنید</p>
        </Modal>
        <Modal title="تغییر نام مستعار" footer={[]} open={changeNameModalOpen} onCancel={() => {
            setChangeNameModalOpen(false);
            setConfirmLoading(false);
            setCurrentAlias('');
        }}>
            <Form
                form={form}
                name="basic"
                className="w-full mt-4 flex flex-col"
                layout='vertical'
                onFinish={changeNameFile}
            
                autoComplete="off"  scrollToFirstError={true}
            >


                <Form.Item
                    label="لطفا نام مستعار جدید را وارد کنید"
                    name="Name"

                    rules={[Validation(EditNameValidation)]}
                >
                    <Input size="large"/>
                </Form.Item>


                <Form.Item className="w-full mt-5">
                    <Button size="large" type="default" onClick={()=>{
                        setConfirmLoading(false);
                        setChangeNameModalOpen(false)
                        setCurrentAlias('');
                        form.resetFields()
                    }}  className="ml-[1%] w-[48%]"
                            htmlType="button">
                        لغو
                    </Button>
                    <Button loading={confirmLoading} size="large" type="primary" className="bg-primary w-[48%] mr-[1%] "
                            htmlType="submit">
                        ذخیره
                    </Button>
                </Form.Item>


            </Form>
        </Modal>
    </>
}
export default ManageFiles;